<script>
  import { fetchLeaders, LEADER_VISIBLE_LENGTH } from "../util/data-fetcher";
  import UserLink from "./UserLink.svelte";
  // import { ethers } from "ethers";
  import CurrentContribution from "./CurrentContribution.svelte";
  import LinkButton from "./LinkButton.svelte";
  import {
    CONTRACT_NETWORK,
    CONTRACTS,
    formatEther,
    GITHUB_RAFFLE_SPEC_URL,
    IS_PRE_LAUNCH,
    isBeforeLaunchStore,
    LINK_ABOUT,
    LINK_EDITIONS,
    PATH_GALLERY,
    SALE_END_DATE_FMT,
    SALE_START_DATE_FMT,
  } from "../util/constants";
  import EditionsTextBlock from "./EditionsTextBlock.svelte";
  import { onMount } from "svelte";
  import { userState } from "../util/highlight-loader";
  import EditionsGallery from "./EditionsGallery.svelte";
  import * as local from "../util/local.js";
  import Paragraph from "./Paragraph.svelte";
  import Footer from "./Footer.svelte";
  import EditionsAutoShuffle from "./EditionsAutoShuffle.svelte";
  import { windowIsMobile } from "../util/window-state";
  import WeeklyBreakdown from "./WeeklyBreakdown.svelte";
  import External from "../icons/external.svelte";
  import ExternalLink from "./ExternalLink.svelte";
  import EtherscanLink from "./EtherscanLink.svelte";
  import InlineSpan from "./InlineSpan.svelte";

  const USE_FAKE_DATA = false;
  const TOP_CONTRIBUTOR_COUNT = 16;
  let leaderPromise;
  let useShortAddress = false;

  let galleryMode = local.get("editions-gallery-mode", "list");
  $: local.set("editions-gallery-mode", galleryMode);

  const WIDTH_BREAKPOINT = 800;
  const SHORT_ADDRESS_BREAKPOINT_FOR_DESKTOP = 900;
  const SHORT_ADDRESS_BREAKPOINT_FOR_MOBILE = 450;

  refresh();
  resize();
  // console.log(ethers.formatEther(158800000000000000n));

  let curUserAddress = null;
  let unsubUserState = userState.subscribe((s) => {
    curUserAddress = s ? s.walletAddress : null;
  });
  onMount(() => {
    return () => {
      unsubUserState();
    };
  });

  function randomize(data) {
    const last = {
      invoker: "0x0989Cd2871B36D638140354731301a32D2409C3a",
      total_contribution: "100000000000000",
      total_minted: 1,
      last_block_number: 6944026,
      last_log_index: 16,
    };
    const res = [];
    for (let i = 0; i < LEADER_VISIBLE_LENGTH; i++) {
      if (i < data.length) res.push(data[i]);
      else res.push(last);
    }
    return res;
  }

  async function refresh() {
    // leaderPromise = fetchLeaders();
    leaderPromise = fetchLeaders().then((leaders) => {
      leaders = leaders.map((leader) => {
        const num = BigInt(leader.total_contribution);
        leader._amount_float = num;
        return leader;
      });
      leaders.sort((a, b) => {
        const aNum = a._amount_float;
        const bNum = b._amount_float;
        if (aNum < bNum) {
          return 1;
        } else if (aNum > bNum) {
          return -1;
        } else {
          return 0;
        }
      });
      return leaders;
    });
    // leaderPromise.then((d) => {
    // console.log(d);
    // });
    //.then((data) => randomize(data));
    // .then(() => {
    //   return new Promise((r) => setTimeout(r, 1000));
    // });
    // leaderPromise = Promise.resolve(
    //   randomize([
    //     {
    //       invoker: "0x63797607631c4c9cF7C1f3c5163aCea5b743aeF3",
    //       total_contribution: "244100000000000000",
    //       total_minted: 6,
    //       last_block_number: 6977456,
    //       last_log_index: 86,
    //     },
    //     {
    //       invoker: "0x66d1B91e5e123115c77aBEE2c69f5647459Ce818",
    //       total_contribution: "159500000000000000",
    //       total_minted: 148,
    //       last_block_number: 6977447,
    //       last_log_index: 126,
    //     },
    //     {
    //       invoker: "0x0989Cd2871B36D638140354731301a32D2409C3a",
    //       total_contribution: "100000000000000",
    //       total_minted: 1,
    //       last_block_number: 6944026,
    //       last_log_index: 16,
    //     },
    //   ])
    // );
  }

  function resize() {
    const w = window.innerWidth;
    const mobile = w <= WIDTH_BREAKPOINT;
    const brk = mobile
      ? SHORT_ADDRESS_BREAKPOINT_FOR_MOBILE
      : SHORT_ADDRESS_BREAKPOINT_FOR_DESKTOP;
    useShortAddress = w < brk;
  }
</script>

<div class="container">
  <section class="main maxwidth">
    <div class="info">
      <EditionsTextBlock>
        <Paragraph>
          Alongside the open edition crowdfund, there is a separate collection
          of 32 limited-edition tokens, initially curated by the artist. There
          are two ways to win these: the first 16 tokens will be distributed via
          weekly random raffles, and the remaining 16 tokens are reserved for
          the top contributors to the crowdfund, based on the leaderboard {$windowIsMobile
            ? "on this page"
            : "to the right"}.
          <!-- The 32 Bit Edition is a limited collection of 32 tokens, initially
          curated by the artist, that runs alongside the crowdfund. It will be
          distributed in two ways: the first 16 tokens will be given to users of
          the system through a weekly random raffle; the remaining 16 will be
          given to the crowdfund's top contributors (by total ETH donated).
          These limited 32 works have a distinct palette and on-chain logic,
          allowing owners to change their designs indefinitely, even after the
          crowdfund closes. -->
          <!-- In addition to the open edition crowdfund, there is a set of 32
          limited-edition tokens that will be distributed over four weeks. Of
          these, 16 will be distributed via a weekly random raffle, and the
          remaining 16 will be distributed to the project's top contributors
          once the crowdfund finishes. If your address has minted one or more
          tokens, it will be automatically entered into that week's raffle. -->
        </Paragraph>
        <div class="auto-shuffle"><EditionsAutoShuffle /></div>
        <Paragraph small italic>
          These editions have a distinct palette and a special on-chain property
          that allows the design to be updated by the token owner, even after
          the crowdfund closes.
        </Paragraph>
      </EditionsTextBlock>
    </div>
    <div class="right-panel">
      <div class="leaderboard-panel">
        <div class="leaderboard">
          <div class="leaderboard-header">
            Top Contributors
            {#if CONTRACT_NETWORK == "sepolia"}
              {" (SEPOLIA TESTNET)"}{/if}
          </div>
          <div class="leaderboard-content">
            {#await leaderPromise}
              <div class="loading">Loading...</div>
            {:then leaders}
              <div class="column-labels">
                <div class="rank">rank</div>
                <div class="address">address</div>
                <div class="contribution">ETH</div>
                <div class="minted"># minted</div>
              </div>
              <div class="leaderboard-scroll">
                {#if leaders.length == 0}
                  <div class="user indexing">
                    <em>
                      {#if $isBeforeLaunchStore}
                        This will be populated after the crowdfund opens on <strong
                          >{SALE_START_DATE_FMT}</strong
                        >.
                      {:else}Indexing contributions, this might take a few
                        minutes...{/if}</em
                    >
                  </div>
                {/if}
                {#each leaders as leader, i}
                  <div
                    class="user"
                    class:lastIncluded={i == TOP_CONTRIBUTOR_COUNT - 1}
                    class:highlight={leader.invoker === curUserAddress}
                    class:excluded={i >= TOP_CONTRIBUTOR_COUNT}
                  >
                    <div class="rank">{i + 1}</div>
                    <div class="address">
                      <UserLink
                        resolve
                        faded={i >= TOP_CONTRIBUTOR_COUNT}
                        addressAsPlaceholder
                        short={useShortAddress}
                        address={leader.invoker}
                      ></UserLink>
                    </div>
                    <div class="contribution">
                      {formatEther(leader.total_contribution)}
                    </div>
                    <div class="minted">
                      {leader.total_minted}
                    </div>
                  </div>
                {/each}
              </div>
            {/await}
          </div>
        </div>
        <div class="footnotes">
          <!-- <div class="error-footnote">
            ⚠️ There is a known bug with the leaderboard ordering that is
            currently being investigated. Hold tight while we work on a fix!
          </div> -->
        </div>
        <div class="current-contribution-container">
          <CurrentContribution></CurrentContribution>
        </div>
      </div>
    </div>
  </section>
  <!-- <div class="current-contribution-container maxwidth">
  </div> -->
  <section class="how-it-works maxwidth">
    <header>How to Win</header>
    <div class="content">
      <Paragraph
        >All contributors to the open edition crowdfund are automatically
        entered to win one of these tokens. The initial designs will be a set of
        32 unique compositions, curated by the artist, but the token owner will
        always have the ability to modify the design on-chain at a later point.</Paragraph
      >
      <div class="mini-header padded">RANDOM ALLOCATION (16x)</div>
      <Paragraph>
        If your address has minted one or more tokens, it will be automatically
        entered into that week's raffle. At the end of each week (each Friday
        evening), the artist will announce the 4x winners, and then within 24
        hours after, mint and distribute a set of curated designs to the winning
        wallets. Note this system resets each week; so contributions in previous
        week will not be counted toward the next week. The mechanics of this is
        explained in the <LinkButton anchor="technical-details"
          >technical details</LinkButton
        > below. After four weeks, all 16 of these tokens will have been distributed.
      </Paragraph>
      <div class="mini-header padded">TOP CONTRIBUTOR ALLOCATION (16x)</div>
      <Paragraph>
        After the crowdfund closes, a tally is made from all contributions to
        the open edition crowdfund over the four weeks, and the top 16
        contributors (by total ETH donated) will be awarded the remaining
        limited-edition tokens.
      </Paragraph>
    </div>
  </section>
  <section class="gallery maxwidth">
    <div class="gallery-toolbar">
      <header>Editions</header>
      <div class="buttons">
        <button
          class="gallery-toolbar-button"
          class:active={galleryMode == "list"}
          on:click={(ev) => {
            ev.preventDefault();
            galleryMode = "list";
          }}
        >
          LIST
        </button>
        <button
          class="gallery-toolbar-button"
          class:active={galleryMode == "thumb"}
          on:click={(ev) => {
            ev.preventDefault();
            galleryMode = "thumb";
          }}
        >
          GRID
        </button>
      </div>
    </div>
    <!-- <div class="gallery-info">
      New tokens will be revealed over the course of the 4 week crowdfund.
    </div> -->
    <EditionsGallery mode={galleryMode} max={32} />
  </section>
  <section class="technical-details maxwidth" id="technical-details">
    <header>Technical Details</header>
    <div class="content">
      <Paragraph>
        The weekly raffles are based on a list of minted tokens between two
        block numbers — not unique wallet addresses — so minting multiple tokens
        from the same address will give you statistically higher odds of winning
        that week's raffle. The raffle will use Ethereum's RANDAO attribute to
        create a fair pseudo-random number generator that even the artist cannot
        manipulate, see <InlineSpan
          ><ExternalLink href={GITHUB_RAFFLE_SPEC_URL}>here</ExternalLink
          >.</InlineSpan
        >
      </Paragraph>
      <Paragraph
        >A "week" is defined by an exact range on the blockchain, starting with
        the first mint after <strong>{SALE_START_DATE_FMT}</strong> and ending
        with the last mint with the crowdfund closure at
        <strong>{SALE_END_DATE_FMT}</strong> (GMT). Dates in between are based
        on Ethereum block numbers and should roughly line up with each Friday at
        5PM GMT. The range below is inclusive. If you visit your token in the <LinkButton
          to={PATH_GALLERY}>GALLERY</LinkButton
        >, it will display which week it was minted within.
      </Paragraph>
      <WeeklyBreakdown></WeeklyBreakdown>
      <Paragraph
        >The top 16 contributors are calculated by summing the total amount of
        ETH paid by each unique address since the beginning of the crowdfund.
        The crowdfund contract (<EtherscanLink
          type="address"
          fragment={CONTRACTS.CROWDFUND.address}
        />) contains a <strong>SeedUpdate</strong> event for each mint with an invoker
        and payment value. If two addresses tie for the same amount of contributed
        ETH, whoever reached that value first will score higher (using block numbers
        as a tie breaker, and if these are equal, transaction indices within blocks
        as a second tie breaker).</Paragraph
      >
    </div>
  </section>
</div>
<Footer></Footer>
<svelte:window on:resize|passive={resize} />

<!--  -->

<!-- <link rel="stylesheet" href="https://mint.highlight.xyz/assets/embed.css" /> -->

<!-- <script type="module" crossorigin="true" src="https://mint.highlight.xyz/assets/embed.js?v=1" id="highlight-embed-script" data-embed-version="2.0"></script> -->

<style>
  .container {
    padding: var(--main-gutter);
    padding-top: var(--main-gutter-vertical);
    padding-bottom: var(--main-gutter-vertical);
    box-sizing: border-box;
    --border-color: black;

    display: flex;
    justify-content: stretch;
    align-items: flex-start;
    flex-direction: column;
    gap: 0px;
    max-width: var(--max-width);
  }
  .how-it-works {
    padding-top: 40px;
  }
  .content {
    max-width: 800px;
  }
  .technical-details {
    padding-top: 40px;
  }
  .gallery-info {
    margin-bottom: 20px;
  }
  .gallery-toolbar {
    display: flex;
    justify-content: space-between;
    justify-content: flex-start;
    align-items: baseline;
  }
  .gallery-toolbar .buttons {
    margin-left: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    gap: 20px;
  }
  .gallery-toolbar-button {
    appearance: none;
    /* padding: 5px 10px; */
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    border-radius: 0;

    text-decoration: none;
    --color: currentColor;
    --shadow-color: currentColor;
    color: var(--color);
    margin: 0;
    text-decoration: none;
    appearance: none;
    border-bottom: 0;
    box-sizing: border-box;
    cursor: pointer;
    outline: 0;
  }
  .mini-header {
    font-weight: bold;
    /* margin-bottom: var(--one-em); */
    margin-bottom: 5px;
  }
  .padded {
    margin-top: 20px;
  }
  .gallery-toolbar-button:last-child {
    /* margin-right: -10px; */
  }
  .gallery-toolbar-button.active {
    cursor: default;
    border-bottom: 1px solid var(--shadow-color);
    /* text-decoration: underline; */
  }
  .main {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: row;
    gap: 0px;
    flex-grow: 1;
    flex-shrink: 0;
    width: calc(100vw - var(--main-gutter) * 2);
  }
  header {
    font-size: 25px;
    margin-bottom: 20px;
  }
  section.gallery {
    padding-top: 40px;
    width: calc(100vw - var(--main-gutter) * 2);
    /* width: 100%; */
  }
  .right-panel {
    gap: 10px;
    box-sizing: border-box;
    /* padding: 20px; */
    flex-basis: 50%;
    /* border-left: 1px solid black; */
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex-direction: row;
    flex-shrink: 0;
    height: 100%;
    flex-grow: 1;
  }

  .info {
    max-width: 720px;
    flex-grow: 1;
    flex-shrink: 1;
    padding-right: var(--main-gutter);
    box-sizing: border-box;
    /* min-height: 360px; */

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0px;
  }
  .indexing {
    font-size: 12px;
    margin: 20px;
    box-sizing: border-box;
  }
  .user {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    /* gap: 10px; */
  }

  .loading {
    padding: 10px;
  }

  .leaderboard-panel {
    width: 100%;

    /* flex-basis: 50%; */
    box-sizing: border-box;
    /* flex-grow: 1; */
    /* flex-shrink: 1; */
    /* padding: 40px; */
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    /* margin-bottom: 10px; */
  }
  .leaderboard {
    --row-gap: 5px;
    --row-padding: 2px var(--row-gap);

    /* flex-basis: 50%; */
    display: flex;
    flex-direction: column;

    border: 1px solid var(--border-color);
    box-shadow:
      0px 3px 0px var(--border-color),
      3px 0px 0px var(--border-color),
      3px 3px 0px var(--border-color),
      3px -1px 0px var(--border-color),
      0px -1px 0px var(--border-color);
  }
  .leaderboard-header {
    padding: 0 5px;
    background: black;
    color: white;
    text-transform: uppercase;
    border-bottom: 1px solid var(--border-color);
  }
  .leaderboard-content {
    overflow: hidden;
    /* min-width: 200px; */
    /* padding: 10px; */
    /* max-height: 210px; */
    /* overflow: hidden; */
    /* overflow-y: scroll; */
  }
  .column-labels {
    padding: var(--row-padding);
    font-size: 11px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-grow: 1;
    gap: var(--row-gap);
  }
  .user {
    /* width: 100%; */
    padding: var(--row-padding);
    gap: var(--row-gap);
  }
  .user.lastIncluded {
    border-bottom: 1px dashed black;
  }
  .user.excluded {
    /* background: #d97676; */
    /* color: #a44848; */
    background: hsla(0, 0%, 65%, 1);
    color: hsla(0, 0%, 45%, 1);
    /* background: #f77760; */
    /* background: tomato; */
    /* color: hsl(0, 0%, 90%); */
    /* opacity: 0.5; */
  }
  .user.highlight {
    background: var(--accent-color);
  }
  .user.highlight.excluded {
    background-color: var(--accent-color-translucent);
  }
  .error-footnote {
    max-width: 550px;
    padding: 20px 0px;
    color: rgb(184, 43, 18);
    font-size: 10px;
  }
  .rank,
  .address,
  .contribution,
  .minted {
    flex-shrink: 0;
    flex-grow: 0;
    /* border-right: 1px dashed black; */
  }
  .rank {
    width: 40px;
  }
  .address {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    flex-grow: 4;
    width: 130px;
    /* max-width: 150px; */
  }
  .contribution {
    width: 70px;
    flex-grow: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .minted {
    width: 60px;
  }
  .current-contribution-container {
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
    /* border: 1px solid black; */
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    /* padding: 20px; */
  }
  .auto-shuffle {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 300px;
    height: 300px;
    aspect-ratio: 1;
  }
  @media screen and (max-width: 380px) {
    .minted {
      display: none;
    }
  }
  @media screen and (max-width: 720px) {
    .auto-shuffle {
      width: 100%;
      max-height: 460px;
      height: auto;
      /* margin-top: 20px; */
      /* margin-bottom: 0px; */
    }
    .gallery-toolbar {
      justify-content: space-between;
    }
    .container {
      /* padding-bottom: calc(0px + var(--main-gutter-vertical)); */
    }
    .info {
      flex-basis: initial;
      width: 100%;
      padding: 0;
    }
    .leaderboard-panel {
      padding: 0px;
      padding-top: 0px;
      width: 100%;
    }
    .right-panel {
      width: 100%;
      padding: 0;
      margin-top: 20px;
      /* border-top: 1px solid black; */
      border-left: none;
    }
    .main {
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
</style>
